import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export  const GetVendors = (AuthStr) => {

     const getUrl = environmentConfig();
     const requestUrl = getUrl+ ConstantsBase.UserNameGet+AuthStr
     
     try {
      const data=  axios({
        method: 'get',
        url: requestUrl,
      //   headers: { 'Content-Type': 'application/json;' , UserId :Authstr },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
     }
     catch (e) {
      return e;
    }
}
